import React, { useMemo } from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import './styles.css';
import { TitlesNav } from '../../global/Styles/titles';

import { FaUserCircle } from 'react-icons/fa';
import MenuMaker from '../Menu/MenuMaker';
import UserTagComponent from './UserTagComponent';

const Nav = (props) => {
  const history = useHistory();
  const location = useLocation();

  const currentPath = location.pathname;
  const menuItems = useMemo(
    () => ({
      operaciones: [
        { name: 'Servicios', url: '/servicios' },
        { name: 'Anticipos', url: '/anticipos' },
        { name: 'Cotizaciones', url: '/cotizacion' },
        { name: 'Conciliaciones', url: '/conciliacion' },
      ],
      parametros: [
        { name: 'Marcas', url: '/marca' },
        { name: 'Tipos de vehículo', url: '/tipoVehiculo' },
        { name: 'Vehículos', url: '/vehiculo' },
        { name: 'Zonas', url: '/zona' },
        { name: 'Contratos', url: '/contrato' },
        { name: 'Tarifas', url: '/tarifa' },
        { name: 'Bonos', url: '/bono' },
        { name: 'Lugar', url: '/lugar' },
        { name: 'Generales', url: '/parametroGeneral' },
      ],
      seguridad: [
        { name: 'Roles', url: '/roles' },
        { name: 'Usuarios', url: '/usuario' },
        { name: 'Clientes', url: '/cliente' },
      ],
      integracion: [
        { name: 'Regionales', url: '/regional' },
        { name: 'Centros de operaciones', url: '/centroOperacion' },
        { name: 'Grupos de unidad de negocio', url: '/unidadNegocio' },
      ],
    }),
    []
  );

  const isSectionActive = (items) => items?.some((item) => item?.url && currentPath.startsWith(item.url));

  const logout = () => {
    props.authLogout?.();
    history.push('/');
  };

  return (
    <header className="h-14 bg-gray-800">
      <nav className="navbar w-full  pr-6">
        <div className="xl:px-4 flex w-full items-center py-2">
          <div className="ml-2 flex ">
            {/* <img
              className="w-18 h-14 object-scale-down"
              src={Logo}
              alt="background"
            /> */}
            <div
              onClick={() => history.push('/dashboard')}
              className="font-heading ml-1  cursor-pointer text-xl font-bold text-gray-200">
              Meneses Ramirez S.A.S.
            </div>
          </div>
          <UserTagComponent />
          <div
            className="menu"
            id="menu">
            <ul className="menu-inner">
              {/* <li
                className="sec-center"
                onClick={() => history.push('/servicios')}>
                <TitlesNav>Servicios</TitlesNav>
              </li>
              <li
                className="sec-center"
                onClick={() => history.push('/anticipos')}>
                <TitlesNav>Anticipos</TitlesNav>
              </li> */}

              <li className="sec-center">
                <TitlesNav>
                  <MenuMaker
                    text={'Operaciones'}
                    isActive={isSectionActive(menuItems.operaciones)}
                    data={menuItems.operaciones}
                  />
                </TitlesNav>
              </li>
              <li className="sec-center">
                <TitlesNav>
                  <MenuMaker
                    text={'Parametros'}
                    isActive={isSectionActive(menuItems.parametros)}
                    data={menuItems.parametros}
                  />
                </TitlesNav>
              </li>
              <li className="sec-center">
                <TitlesNav>
                  <MenuMaker
                    text={'Seguridad'}
                    isActive={isSectionActive(menuItems.seguridad)}
                    data={menuItems.seguridad}
                  />
                </TitlesNav>
              </li>
              <li className="sec-center">
                <TitlesNav>
                  <MenuMaker
                    text={'Integración'}
                    align="right"
                    isActive={isSectionActive(menuItems.integracion)}
                    data={menuItems.integracion}
                  />
                </TitlesNav>
              </li>
              {/* <li className="sec-center">
                <TitlesNav>Herramientas</TitlesNav>
              </li> */}
              {/*USER*/}
              <li className="">
                <TitlesNav>
                  <MenuMaker
                    text={
                      <span className="flex flex-row items-center gap-3">
                        {props.auth.data === undefined ? '' : props.auth.data.user.TERCERO_NOMBRE1}
                        <span className="mt-1">
                          <FaUserCircle></FaUserCircle>
                        </span>
                      </span>
                    }
                    align="right"
                    data={[
                      {
                        name: 'Configuración',
                        url: '/perfil',
                      },
                      {
                        name: 'Cerrar Sesión',
                        url: '',
                        onClick: logout,
                      },
                    ]}
                  />
                </TitlesNav>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => ({
  authLogout: () => dispatch({ type: 'LOG_OUT' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Nav);
